import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { allliststaff, grouplist } from "../../../services/admin";
import { bmamreportcreate, bmamreportview } from "../../../services/bmam";

export const PURPOSES = [
    { value: "grt", label: "GRT" },
    { value: "center_meeting", label: "Center Meeting" },
    { value: "special_meeting", label: "Special Meeting" },
    { value: "od_following", label: "OD Following" },
];

export const STATUSES = [
    { value: "very_good", label: "Very Good" },
    { value: "good", label: "Good" },
    { value: "bad", label: "Bad" },
];

/** Center dropdown entry that stands for the "All Center's View" row. */
const ALLCENTER = { value: "all", label: "All Center's View" };

/** Only Manager staff file these reports, so the Name dropdown is scoped to them. */
export const MANAGERROLE = 2;

export default function AddBmamReport() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [urllink, setUrllink] = useState("");
    const [loading, setLoading] = useState(false);
    const [psubmit, setPsubmit] = useState(false);
    const [perror, setPerror] = useState("");

    const [rdate, setRDate] = useState(moment().format("YYYY-MM-DD"));
    const [otype, setOType] = useState("");
    const [slist, setSlist] = useState([]);
    const [staffid, setStaffId] = useState("");
    const [glist, setGlist] = useState([ALLCENTER]);
    const [mgrpid, setMGrpId] = useState("");
    const [grpid, setGrpId] = useState("");
    const [purpose, setPurpose] = useState("");
    const [status, setStatus] = useState("");
    const [report, setReport] = useState("");
    const [remark, setRemark] = useState("");
    const [bmsign, setBmSign] = useState("");

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        allliststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSlist(res.data.details.filter((item) => item.role_id == MANAGERROLE));
            }
        });

        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                const arr = res.data.map((item) => ({
                    value: item.id,
                    label: item.group_name,
                }));
                setGlist([ALLCENTER, ...arr]);
            }
        });

        if (path === "reportdetail") {
            bmamreportview(id).then((res) => {
                if (res.status === true && res.data.details !== null) {
                    const data = res.data.details;
                    setRDate(moment(data.report_date).format("YYYY-MM-DD"));
                    setOType(data.officer_type);
                    setStaffId(data.staff_id);
                    setPurpose(data.purpose);
                    setStatus(data.status);
                    setReport(data.report !== null ? data.report : "");
                    setRemark(data.remark !== null ? data.remark : "");
                    setBmSign(data.bm_signature !== null ? data.bm_signature : "");

                    if (data.all_centers) {
                        setGrpId("all");
                        setMGrpId(ALLCENTER);
                    } else {
                        setGrpId(data.group_id);
                        setMGrpId({ value: data.group_id, label: data.group_name });
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handlecenter(e) {
        if (e !== null) {
            setMGrpId(e);
            setGrpId(e.value);
        } else {
            setMGrpId("");
            setGrpId("");
        }
    }

    function handlesubmit(e) {
        e.preventDefault();
        setPerror("");
        setPsubmit(true);

        if (
            rdate !== "" &&
            otype !== "" &&
            staffid !== "" &&
            grpid !== "" &&
            purpose !== "" &&
            status !== ""
        ) {
            setLoading(true);
            setPsubmit(false);

            const temp = new FormData();
            temp.append("report_date", rdate);
            temp.append("officer_type", otype);
            temp.append("staff_id", staffid);
            temp.append("group_id", grpid === "all" ? "" : grpid);
            temp.append("all_centers", grpid === "all" ? 1 : 0);
            temp.append("purpose", purpose);
            temp.append("status", status);
            temp.append("report", report);
            temp.append("remark", remark);
            temp.append("bm_signature", bmsign);
            temp.append("branch_id", localStorage.getItem("branch"));
            if (urllink === "reportdetail") {
                temp.append("id", id);
            }

            bmamreportcreate(temp).then((res) => {
                setLoading(false);
                if (res.status === true) {
                    toast.success(res.message);
                    navigate("/bmam/allreport");
                } else {
                    setPerror(res.message);
                }
            });
        }
    }

    const title = urllink === "reportdetail" ? "BM & AM Report Detail" : "Add BM & AM Report";

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>BM &amp; AM Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {title}
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <Card.Header>
                                    <h2 className="main-content-title tx-24 mg-b-5">{title}</h2>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Date <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={rdate}
                                                    onChange={(e) => setRDate(e.target.value)}
                                                />
                                                {psubmit && rdate === "" && (
                                                    <span className="text-danger">Date is required</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    BM / AM <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={otype}
                                                    onChange={(e) => setOType(e.target.value)}
                                                >
                                                    <option value="">Select BM / AM</option>
                                                    <option value="BM">BM</option>
                                                    <option value="AM">AM</option>
                                                </select>
                                                {psubmit && otype === "" && (
                                                    <span className="text-danger">
                                                        BM / AM is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Name <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={staffid}
                                                    onChange={(e) => setStaffId(e.target.value)}
                                                >
                                                    <option value="">Select Name</option>
                                                    {slist.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.id}>
                                                                {item.staff_name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && staffid === "" && (
                                                    <span className="text-danger">Name is required</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Center Name <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Center"
                                                    value={mgrpid}
                                                    options={glist}
                                                    onChange={handlecenter}
                                                    isSearchable={true}
                                                    isClearable
                                                />
                                                {psubmit && grpid === "" && (
                                                    <span className="text-danger">
                                                        Center Name is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Purpose of Visit
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={purpose}
                                                    onChange={(e) => setPurpose(e.target.value)}
                                                >
                                                    <option value="">Select Purpose</option>
                                                    {PURPOSES.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && purpose === "" && (
                                                    <span className="text-danger">
                                                        Purpose of Visit is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Status <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={status}
                                                    onChange={(e) => setStatus(e.target.value)}
                                                >
                                                    <option value="">Select Status</option>
                                                    {STATUSES.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && status === "" && (
                                                    <span className="text-danger">
                                                        Status is required
                                                    </span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col xl={6} sm={12}>
                                            <div className="mb-3">
                                                <label className="form-label">Reports</label>
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    placeholder="Enter Reports"
                                                    value={report}
                                                    onChange={(e) => setReport(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xl={6} sm={12}>
                                            <div className="mb-3">
                                                <label className="form-label">Remark</label>
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    placeholder="Enter Remark"
                                                    value={remark}
                                                    onChange={(e) => setRemark(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">BM Signature</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter BM Signature"
                                                    value={bmsign}
                                                    onChange={(e) => setBmSign(e.target.value)}
                                                />
                                            </div>
                                        </Col>
                                        {perror && <span className="text-danger">{perror}</span>}
                                    </Row>
                                    <div className="text-end">
                                        <a className="btn btn-success me-2" onClick={handlesubmit}>
                                            {urllink === "reportdetail" ? "Update" : "Submit"}
                                        </a>
                                        <a
                                            className="btn btn-secondary"
                                            onClick={() => navigate("/bmam/allreport")}
                                        >
                                            Back
                                        </a>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}
